/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface OauthControllerCheckDuplicateEmail$Params {

/**
 * 이메일
 */
  newEmail: string;
}

export function oauthControllerCheckDuplicateEmail(http: HttpClient, rootUrl: string, params: OauthControllerCheckDuplicateEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, oauthControllerCheckDuplicateEmail.PATH, 'get');
  if (params) {
    rb.query('newEmail', params.newEmail, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

oauthControllerCheckDuplicateEmail.PATH = '/api/oauth/check-duplicate-email';
